import { CcRequirementType } from "server/models"
import { OrderType } from "client/utils"

export type CcRequirementTypeValidation = { [key in keyof CcRequirementType]?: string}

export interface CcRequirementTypeList { [methodId: number]: CcRequirementType }
export interface CcRequirementTypeFilters {
    search?: string
}

export interface CcRequirementTypeState {
    typeList: CcRequirementTypeList
    typeIds: readonly number[]
    typeEdit: CcRequirementType

    sortColumn: keyof CcRequirementType
    sortOrder: OrderType
    filters: CcRequirementTypeFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REQUIREMENT_TYPE_LIST = "CC_REQUIREMENT_TYPE_LIST"
export const CC_REQUIREMENT_TYPE_IDS = "CC_REQUIREMENT_TYPE_IDS"
export const CC_REQUIREMENT_TYPE_EDIT = "CC_REQUIREMENT_TYPE_EDIT"

export const CC_REQUIREMENT_TYPE_SORT = "CC_REQUIREMENT_TYPE_SORT"
export const CC_REQUIREMENT_TYPE_FILTERS = "CC_REQUIREMENT_TYPE_FILTERS"

export const CC_REQUIREMENT_TYPE_RELOAD_LIST = "CC_REQUIREMENT_TYPE_RELOAD_LIST"
export const CC_REQUIREMENT_TYPE_RELOAD_EDIT = "CC_REQUIREMENT_TYPE_RELOAD_EDIT"
